'use client'
import {HotelEnquireSlideout} from './HotelEnquireSlideout'
import {Button, Select} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import {ChangeEvent, useState} from 'react'
import PersonSVG from '@local/assets/svgs/icon-person.svg'
import DatePicker from 'react-date-picker'
import DateSVG from '@local/assets/svgs/icon-date.svg'
import {HotelEnquireMobileSelect} from './HotelEnquireMobileSelect'

import ChevronSVG from '@local/assets/svgs/chevron.svg'

interface BottomBarProps {
	title: string;
	buttonTitle: string;
	hotelEnquireQuestions: {
		dateFlexibility: Array<string>;
		nightCounts: Array<string>;
		guestCounts: Array<string>;
	};
	successText: string;
	successTitle: string;
}

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

const formatDate = (date: Value) => {
	if (Array.isArray(date)) {
		return `${date[0]?.toLocaleDateString('en-GB', {
			day: '2-digit',
			month: 'short',
		})} - ${date[1]?.toLocaleDateString('en-GB', {
			day: '2-digit',
			month: 'short',
		})}`
	}
	return date?.toLocaleDateString('en-GB', {day: '2-digit', month: 'short'})
}

const BottomBar = ({
	title,
	hotelEnquireQuestions,
	buttonTitle,
	successText,
	successTitle,
}: BottomBarProps) => {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false)
	const [isOpen, setIsOpen] = useState<boolean>(false)
	const [guestCounts, setGuestCounts] = useState<string>('')
	const [arrivalDate, setArrivalDate] = useState<Value>(null)
	const [departureDate, setDepartureDate] = useState<Value>(null)

	const guestOptions = hotelEnquireQuestions.guestCounts.map((guestCount) => ({
		label: guestCount,
		value: guestCount,
	}))

	const handleGuests = (e: ChangeEvent<HTMLSelectElement>) => {
		setGuestCounts(e.target.value)
	}

	const reservation = {
		arrivalDate,
		departureDate,
		guestCounts,
		stay: title,
	}

	return (
		<>
			<div className={cx('fixed z-50 bottom-10 w-full  px-10 py-3')}>
				<div className='relative flex w-full lg:justify-end gap-8 z-'>
					{/* <div className=' flex w-full justify-end gap-8 z-1 lg-max:hidden date-picker-container-hotel-enquire'>
						<DatePicker
							onChange={setArrivalDate}
							value={arrivalDate}
							format={arrivalDate ? 'Arrival: dMMM' : 'Arrival Date'}
							minDate={new Date()}
							locale='en-US'
							calendarProps={{
								next2Label: null,
								prev2Label: null,
								nextLabel: null,
								prevLabel: null,
							}}
							calendarIcon={
								<DateSVG className='col-start-1 row-span-full w-16 h-16' />
							}
							clearIcon={false} />
						<DatePicker
							className='h-44 appearance-none focus:outline-none focus:ring-0'
							onChange={setDepartureDate}
							minDate={
								arrivalDate
									? new Date(arrivalDate?.getTime() + 24 * 60 * 60 * 1000)
									: undefined
							}
							value={departureDate}
							locale='en-US'
							format={departureDate ? 'Departure: dMMM' : 'Departure Date'}
							calendarProps={{
								next2Label: null,
								prev2Label: null,
								nextLabel: null,
								prevLabel: null,
								allowPartialRange: true,
							}}
							calendarIcon={
								<DateSVG className='col-start-1 row-span-full w-16 h-16' />
							}
							clearIcon={false} />
						<Select
							key={`guest-select-${guestCounts}`}
							theme='light'
							name='guest'
							id='product-hero-guest-select'
							placeholder='Guests'
							onChange={handleGuests}
							options={guestOptions}
							value={guestCounts}
							containerClassName='border-0 w-120'
							className='border-0 border-r !rounded-none'
							keepPrefixIcon
							prefixIcon={<PersonSVG className='w-16 h-16 mr-4 shrink-0' />} />
					</div> */}
					<Button
						small
						variant='secondary'
						label='Select room and guests'
						onClick={() => {
							setIsMobileMenuOpen(!isMobileMenuOpen)
						}}
						className={cx(
							'lg:hidden w-full',
							'rounded-e-none pl-16 pr-12 justify-between',
						)}>
						{guestCounts && arrivalDate && departureDate
							? (
								<span className='text-11 font-medium tracking-wide overflow-clip overflow-ellipsis whitespace-nowrap'>
									{formatDate(arrivalDate)} - {formatDate(departureDate)},{' '}
									{guestCounts} guests
								</span>
							)
							: (
								<span className='text-11 font-medium tracking-wide overflow-clip overflow-ellipsis  whitespace-nowrap'>
									Select date and guests
								</span>
							)}
						<ChevronSVG
							className={cx(
								'w-8 h-8 transfrom-gpu duration-300 ease-quart-out transition-transform',
								isMobileMenuOpen ? 'rotate-180' : 'rotate-0 duration-200',
							)}
							aria-hidden />
					</Button>
					<Button
						small
						variant='primary'
						disabled={!guestCounts || !arrivalDate || !departureDate}
						onClick={() => setIsOpen(true)}>
						{buttonTitle}
					</Button>
				</div>
				<HotelEnquireMobileSelect
					isOpen={isMobileMenuOpen}
					guestOptions={guestOptions.map((guest) => ({
						label: guest.label,
						value: guest.value,
					}))}
					guestCounts={guestCounts}
					onClickClose={() => setIsMobileMenuOpen(false)}
					onChangeArrivalDate={setArrivalDate}
					onChangeDepartureDate={setDepartureDate}
					arrivalDate={arrivalDate}
					onChangeGuests={handleGuests}
					departureDate={departureDate} />
			</div>

			<HotelEnquireSlideout
				isOpen={isOpen}
				onClickClose={() => setIsOpen(false)}
				successText={successText}
				successTitle={successTitle}
				hotelEnquireQuestions={hotelEnquireQuestions}
				reservation={reservation} />
		</>
	)
}

export default BottomBar
